export const tratamiento = {
  SI: true,
  NO: false,
}

export const translatetratamiento = {
  true: 'TRATAMIENTO.SI',
  false: 'TRATAMIENTO.NO'
}